import { LittleEmperorsIcon } from 'components/icons';
import { colorConstants } from 'data/constants';
import Link from 'next/link';
import styles from './JoinNow.module.css';

const JoinNow = () => {
  return (
    <div className={styles.container}>
      <LittleEmperorsIcon
        color={colorConstants.black}
        className={styles.logo}
      />
      <h4>Join now</h4>
      <p>
        Sign up to Little Emperors to start taking advantage of our preferential
        rates and complimentary benefits
      </p>
      <Link href={'/membership'}>
        <a className={styles.button}>Select membership</a>
      </Link>
    </div>
  );
};

export default JoinNow;
